const londonDateParts = (value) => {
  const date = value?.toDate
    ? value.toDate()
    : Number.isFinite(value?.seconds)
      ? new Date(value.seconds * 1000)
      : value instanceof Date
        ? value
        : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Europe/London",
    }).formatToParts(date).map(({ type, value: part }) => [type, part]),
  );
  return { year: parts.year, month: parts.month, day: parts.day };
};

export const statementPasswordFromDob = (value) => {
  if (!value) return "";
  const text = typeof value === "string" ? value.trim() : "";
  const iso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  const uk = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  const parts = iso
    ? { year: iso[1], month: iso[2], day: iso[3] }
    : uk
      ? { year: uk[3], month: uk[2], day: uk[1] }
      : londonDateParts(value);
  if (!parts) return "";
  const year = String(parts.year).padStart(4, "0");
  const month = String(parts.month).padStart(2, "0");
  const day = String(parts.day).padStart(2, "0");
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (
    date.getUTCFullYear() !== Number(year) ||
    date.getUTCMonth() + 1 !== Number(month) ||
    date.getUTCDate() !== Number(day)
  ) return "";
  return `${day}${month}${year}`.replace(/^0/, "");
};
